import styled from 'styled-components';
import { motion } from 'framer-motion';
import fonts from '../../design-system/fonts';
import { colors } from '../../design-system/colors';

export const PopoverOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 5, 0, 0.4);
  backdrop-filter: blur(8px);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 0;

  @media (max-width: 768px) {
    align-items: center;
    justify-content: center;
    padding: 16px;
  }
`;

export const FormContainer = styled(motion.div)`
  background: white;
  width: 100%;
  max-width: 440px;
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.15);
  position: relative;
  margin-left: 8px;
  margin-bottom: 8px;
`;

export const FormHeader = styled.div`
  background: ${colors.deepCharcoal};
  color: white;
  padding: 32px 32px 24px;
  position: relative;

  h3 {
    margin: 0;
    font-size: 22px;
    font-weight: 800;
    font-family: ${fonts.headline};
    line-height: 1.2;
    letter-spacing: -0.02em;
    max-width: 280px;
  }

  p {
    margin: 12px 0 0;
    font-size: 14px;
    opacity: 0.6;
    font-family: ${fonts.body};
    line-height: 1.4;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 18px;

  &:hover {
    background: ${colors.sapphire};
    transform: rotate(90deg);
  }
`;

export const FormBody = styled.form`
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 480px) {
    padding: 24px;
    gap: 16px;
  }
`;

export const InputGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;

  label {
    font-size: 11px;
    font-weight: 700;
    color: ${colors.deepCharcoal};
    opacity: 0.4;
    text-transform: uppercase;
    letter-spacing: 0.1em;
  }

  input,
  textarea {
    width: 100%;
    box-sizing: border-box;
    padding: 14px 16px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: #fcfcfc;
    border-radius: 10px;
    font-family: ${fonts.body};
    font-size: 15px;
    color: ${colors.deepCharcoal};
    transition: all 0.25s ease;

    &:focus {
      outline: none;
      border-color: ${colors.sapphire};
      background: white;
      box-shadow: 0 0 0 4px rgba(28, 80, 196, 0.05);
    }

    &::placeholder {
      color: rgba(0, 0, 0, 0.25);
    }
  }

  textarea {
    resize: none;
  }
`;

export const SubmitButton = styled.button`
  background: ${colors.sapphire};
  color: white;
  border: none;
  padding: 16px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 10px 20px rgba(28, 80, 196, 0.15);

  &:hover {
    background: #143c82;
    transform: translateY(-3px);
    box-shadow: 0 15px 30px rgba(28, 80, 196, 0.25);
  }

  &:active {
    transform: translateY(-1px);
  }

  &:disabled {
    background: #e0e0e0;
    color: #999;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const SuccessOverlay = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  text-align: center;

  svg {
    color: #22c55e;
    margin-bottom: 24px;
  }

  h4 {
    font-size: 24px;
    font-weight: 800;
    color: ${colors.deepCharcoal};
    margin: 0 0 12px;
    font-family: ${fonts.headline};
  }

  p {
    font-size: 16px;
    color: ${colors.deepCharcoal};
    opacity: 0.6;
    line-height: 1.5;
    margin: 0;
  }
`;
